import { render } from "./BootstrapBreakpoints.vue?vue&type=template&id=f11bb17c&ts=true"
import script from "./BootstrapBreakpoints.vue?vue&type=script&lang=ts"
export * from "./BootstrapBreakpoints.vue?vue&type=script&lang=ts"

import "./BootstrapBreakpoints.vue?vue&type=style&index=0&id=f11bb17c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__